import { compose, find, get } from 'lodash/fp';

interface ReduceSwitchPair<T> {
    cond: boolean;
    value: T;
}

export const createConditionSwitch = <T>(conditionsValuesMap: ReduceSwitchPair<T>[]) =>
    compose(get<ReduceSwitchPair<T>, 'value'>('value'), find<ReduceSwitchPair<T>>({ cond: true }))(conditionsValuesMap);
